import { addNotification } from "@/shared/states/notification";
import { useEffect, useState } from "react";
import {
  fetchIntakeFormQuestions,
  type IntakeFormQuestion,
} from "../requests/vendor-intake-form-response";

interface UseIntakeFormQuestionsProps {
  questionsJsonUrl: string;
}

export const useIntakeFormQuestions = ({
  questionsJsonUrl,
}: UseIntakeFormQuestionsProps) => {
  const [questions, setQuestions] = useState<IntakeFormQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch questions from JSON URL
  useEffect(() => {
    const loadQuestions = async () => {
      try {
        setIsLoading(true);
        console.log("Fetching questions from URL:", questionsJsonUrl);
        const fetchedQuestions = await fetchIntakeFormQuestions(questionsJsonUrl);
        console.log("Fetched questions:", fetchedQuestions);

        // Filter out hidden questions
        const visibleQuestions = fetchedQuestions.filter((q) => !q.hidden_from_user);
        console.log("Visible questions after filtering:", visibleQuestions);
        setQuestions(visibleQuestions);
      } catch (error) {
        console.error("Error loading questions:", error);
        addNotification({
          type: "error",
          message: "Failed to load intake form questions",
        });
      } finally {
        setIsLoading(false);
        console.log("Loading complete, isLoading set to false");
      }
    };

    console.log("useEffect triggered with questionsJsonUrl:", questionsJsonUrl);
    if (questionsJsonUrl) {
      void loadQuestions();
    } else {
      // If no URL provided, set loading to false immediately
      console.log("No questionsJsonUrl provided, setting isLoading to false");
      setIsLoading(false);
    }
  }, [questionsJsonUrl]);

  return {
    questions,
    isLoading,
  };
};
